import React, { Component } from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import ModAccordionsItem from './ModAccordionsItem';


export default class ModAccordions extends Component {
    render () {
	    let block = this.props.block;
	    return (
	        <div className={'l-block l-block--display-' + block.display + ' scope-' + block.text_color} style={{backgroundColor: block.block_color}}>
	        	
	        	<div className="l-grid">
	        		{block.heading &&
			        	<div className="l-grid__col">
			        		<ScrollAnimation animateIn="fadeIn" animateOnce={true}>
						        <h1 className="c-heading c-heading--large c-heading--large-space">{ block.heading }</h1>
				        	</ScrollAnimation>
			        	</div>
		        	}
		        	<div className="l-grid__col">
		        		<ScrollAnimation animateIn="fadeIn" animateOnce={true}>
		        			<div className="c-accordions">
					        	{block.row.map((accordion,i) =>
									{
										return (
											<ModAccordionsItem item={accordion} key={i}></ModAccordionsItem>
										)
									}
								)}
							</div>
			        	</ScrollAnimation>
		        	</div>
		        </div>
	        
			</div>
		)
	};
};
